(function ($) {

/**
 * Loads an image with the given ID and displays it in the zoom container.
 *
 * @param {number} id - The ID of the image to load.
 * @return {void} This function does not return a value.
 */
    function loadImage(id) {

        let zoom = $('section#gallery > .projects > .zoom');

        $.ajax({
            url: get_image.url + "/" + id,
            type: "GET",
            dataType: "json",
            beforeSend: function () {

                // console.log('loading...')
                zoom.html("<div class='loading'><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><circle fill='#FFFFFF' stroke='#FFFFFF' stroke-width='15' r='15' cx='40' cy='65'><animate attributeName='cy' calcMode='spline' dur='0.8' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.4'></animate></circle><circle fill='#FFFFFF' stroke='#FFFFFF' stroke-width='15' r='15' cx='100' cy='65'><animate attributeName='cy' calcMode='spline' dur='0.8' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='-.2'></animate></circle><circle fill='#FFFFFF' stroke='#FFFFFF' stroke-width='15' r='15' cx='160' cy='65'><animate attributeName='cy' calcMode='spline' dur='0.8' values='65;135;65;' keySplines='.5 0 .5 1;.5 0 .5 1' repeatCount='indefinite' begin='0'></animate></circle></svg></div>");


            },
            success: function (res) {

                if (res) {
                    zoom.html(res);
                    let img = zoom.find('img');

                    img.on('load', function () {
                        setTimeout(function () {
                            img.addClass('show');
                        }, 100);
                    });

                }
            }
        })
    }

    $(document).ready(function () {

        let selected = $('section#gallery > .projects > .nav > figure:nth-child(1)');
        let img = $('section#gallery > .projects > .nav > figure:nth-child(1) > img');
        let id = img.attr('class').split("wp-image-")[1];

        loadImage(id);

        $(selected).addClass('active');

        $('section#gallery > .projects > .nav > figure').click(function () {

            $('section#gallery > .projects > .nav > figure').removeClass('active');
            $(this).addClass('active');
            let id = $(this).find('img').attr('class').split("wp-image-")[1];

            let zoom = $('section#gallery > .projects > .zoom');

            $(zoom).find('picture img').css('opacity', '0');

            setTimeout(function () {
                loadImage(id);
            }, 500);
            
        })
    })

})(jQuery)